import SearchBarTemplate from './search-bar.html';
import Ricola from 'ricola3';
import rcTable from 'ricola3';

class SearchCtrl {
  constructor() {
    'ngInject';
    
    this.ignoreSpellcheck = false;
    this.spellcheckTerm = "";
    
    this.sources = [
      {
        label: 'UP',
        filter: 'up'
      },
      {
        label: 'Jobs',
        filter: 'jobs'
      }
    ];
    
    this.checkbox = {
	        sources:
          {
            up: true,
            jobs: true
          }
    };
  }
  
  search(searchTerm, ignoreSpellcheck) {
    this.searchTerm = searchTerm;
    this.ignoreSpellcheck = ignoreSpellcheck;
    this.lastSearchTerm = angular.copy(searchTerm);
    this.onSearch(
      {
        $event: {
          searchTerm: searchTerm, 
          filter: this.createExcludeFilter(this.checkbox.sources), 
          ignoreSpellcheck: ignoreSpellcheck,
          spellcheckTerm: this.spellcheckTerm
        }
      });
  }
  
  createExcludeFilter(filter) {
    var filterArray = [];
    for (let key in filter) {
      if (!filter[key]) {
        filterArray.push(key);
      }
    }
    return filterArray.join();
  }
  
  filterChange() {
    this.search(this.searchTerm, true);
  }
}

export default {
  bindings: {
    searchTerm: '<',
    spellcheck: '<',
    onSearch: '&'
  },
  controller: SearchCtrl,
  template: SearchBarTemplate
};  


// WEBPACK FOOTER //
// ./src/search-interface/shared/components/search-bar/search-bar.js